module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "reservation"
  }, [_c('div', {
    staticClass: "background",
    on: {
      "click": _vm.hide
    }
  }), _vm._v(" "), (!_vm.hasLoaded) ? _c('loader') : _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [(_vm.page == 'invoice') ? _c('invoice', {
    attrs: {
      "id": _vm.reservation.id
    }
  }) : _vm._e(), _vm._v(" "), (_vm.page == 'products') ? _c('card', [(_vm.page == 'products') ? _c('products', {
    attrs: {
      "id": _vm.reservation.id
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('card', [_c('strong', [_vm._v("Total cost")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("DKK")]), _vm._v(" " + _vm._s(_vm._f("moneyFormat")(_vm._f("fixedNumber")(_vm.total, 2))) + "\n\n                    "), (_vm.reservation.room) ? [_c('hr'), _vm._v(" "), _c('strong', [_vm._v("Room")]), _c('br'), _vm._v("\n                        " + _vm._s(_vm.reservation.room.title) + "\n                    ")] : _vm._e(), _vm._v(" "), (_vm.reservation.type) ? [_c('hr'), _vm._v(" "), _c('strong', [_vm._v("Payment")]), _c('br'), _vm._v(" "), _c('multiselect', {
    attrs: {
      "placeholder": "Type",
      "track-by": "label",
      "label": "label",
      "options": _vm.typeOptions,
      "close-on-select": true,
      "show-labels": false
    },
    model: {
      value: (_vm.selectedType),
      callback: function($$v) {
        _vm.selectedType = $$v
      },
      expression: "selectedType"
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "list-group"
  }, [_c('router-link', {
    staticClass: "list-group-item",
    attrs: {
      "to": {
        name: 'reservations.view',
        params: {
          id: _vm.reservation.id
        }
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-pencil fa-fw"
  }), _vm._v("  \n                        Edit reservation\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "list-group-item",
    on: {
      "click": function($event) {
        return _vm.navigate('products')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-shopping-cart fa-fw"
  }), _vm._v("  \n                        Edit products\n                    ")]), _vm._v(" "), (!_vm.paid) ? _c('button', {
    staticClass: "list-group-item",
    on: {
      "click": _vm.markPaid
    }
  }, [_c('span', {
    staticClass: "fa fa-credit-card fa-fw"
  }), _vm._v("  \n                        Mark as paid\n                    ")]) : _c('button', {
    staticClass: "list-group-item",
    on: {
      "click": _vm.markUnPaid
    }
  }, [_c('span', {
    staticClass: "fa fa-ban fa-fw text-danger"
  }), _vm._v("  \n                        Mark as unpaid\n                    ")])], 1)], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28684e67","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/Overlay.vue
// module id = 387
// module chunks = 1